import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PubSub from "pubsub-js";
import { Prompt } from "react-router";

import { Layout } from "../components";
import { getMasterContactList, saveMasterContactList } from "../emailCampaign.store";

import { MCLHeader, MCLContent } from "./";

const MAX_WIDTH = "1920px";

const MasterContactList = ({ history, emailCampaign, getMasterContactList, saveMasterContactList }) => {
  const [searchText, setSearchText] = useState("");
  const [contactsDataFromDb, setContactsDataFromDb] = useState([]);
  const [viewableContacts, setViewableContacts] = useState([]);
  const [contactsDataToSave, setContactsDataToSave] = useState([]);
  const [selectedCompanyToFilter, setSelectedCompanyToFilter] = useState(null);
  const [companyOptions, setCompanyOptions] = useState([]);

  useEffect(() => {
    getMasterContactList();
  }, []);

  const topic = "edc-contact-save";
  const onMessage = (_topic, data) => {
    saveMasterContactList({ contacts: data });
  };

  useEffect(() => {
    const token = PubSub.subscribe(topic, onMessage);

    return function cleanup() {
      // Needs time to allow the event to propogate the message for the save before unsubscribing
      setTimeout(() => {
        PubSub.unsubscribe(token);
      }, 1000);
    };
  });

  useEffect(() => {
    setContactsDataFromDb(emailCampaign.masterContactList);
    setContactsDataToSave(emailCampaign.masterContactList);
  }, [emailCampaign, emailCampaign.masterContactList]);

  useEffect(() => {
    setViewableContacts(contactsDataFromDb);
    const companiesInList = contactsDataFromDb.map(contact => ({ id: contact?.company?.companyId, label: contact?.company?.name }));
    const uniqueCompaniesInList = companiesInList.filter((elem, index) => companiesInList.findIndex(obj => obj.id === elem.id) === index);
    const companiesInListWithNull = [{ id: -1, label: "All companies" }, ...uniqueCompaniesInList];
    setCompanyOptions(companiesInListWithNull);
  }, [contactsDataFromDb]);

  useEffect(() => {
    // If user selects a company filter, set the company filter first and then if there is search text, filter on that.
    if (Boolean(selectedCompanyToFilter) && selectedCompanyToFilter > 0) {
      const newViewableContacts = contactsDataFromDb?.filter(contact => contact?.company?.companyId === selectedCompanyToFilter);
      searchText ? setViewableContacts(filteredContactsBySearchText(newViewableContacts)) : setViewableContacts(newViewableContacts);
    } else {
      searchText ? setViewableContacts(filteredContactsBySearchText(contactsDataFromDb)) : setViewableContacts(contactsDataFromDb);
    }
  }, [selectedCompanyToFilter, searchText]);

  useEffect(() => {
    setViewableContacts(contactsDataToSave);
  }, [contactsDataToSave]);

  const filteredContactsBySearchText = arr => arr.filter(contact => contact?.contactName?.toLowerCase().includes(searchText.toLowerCase()));

  const handleSaveListClicked = () => {
    setContactsDataFromDb(contactsDataToSave);
    setViewableContacts(contactsDataToSave);
    saveMasterContactList({ contacts: contactsDataToSave });
  };

  const handleCancelClicked = () => {
    setViewableContacts(contactsDataFromDb);
    setSearchText("");
    setSelectedCompanyToFilter(null);
  };

  const difference = contactsDataToSave.map((saving, inx) => saving.included === contactsDataFromDb[inx].included).some(bool => !bool);

  return (
    <>
      <Prompt
        when={difference}
        message={JSON.stringify({
          topic,
          data: contactsDataToSave
        })}
      />
      <Layout
        header={
          <MCLHeader
            maxWidth={MAX_WIDTH}
            history={history}
            contacts={contactsDataToSave}
            handleSaveListClicked={handleSaveListClicked}
            handleCancelClicked={handleCancelClicked}
          />
        }
        content={
          <MCLContent
            maxWidth={MAX_WIDTH}
            viewableContacts={viewableContacts}
            history={history}
            setContactsDataToSave={setContactsDataToSave}
            selectedCompanyToFilter={selectedCompanyToFilter}
            setSelectedCompanyToFilter={setSelectedCompanyToFilter}
            companyOptions={companyOptions}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        }
      />
    </>
  );
};

const mapStateToProps = ({ emailCampaign }) => ({ emailCampaign });

export default compose(
  connect(mapStateToProps, {
    getMasterContactList,
    saveMasterContactList
  })
)(MasterContactList);
